import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Form, Input, InputGroup, Label } from 'reactstrap';
import classnames from 'classnames';
import { updateReview, newReview } from '../actions/reviewActions';

const ReviewStep4 = ({
  reviews,
  cart,
  product,
  updateReview,
  newReview,
  nextStep,
  previousStep,
}: any) => {
  const [errors, setErrors] = useState<any>({});
  const prevSuccessRef = useRef(reviews.success);

  useEffect(() => {
    setErrors(reviews.errors);
  }, [reviews.errors]);

  useEffect(() => {
    if (reviews.success && prevSuccessRef.current !== reviews.success) {
      nextStep();
    }
    prevSuccessRef.current = reviews.success;
  }, [reviews.success]);

  const handleChange = (e) => {
    const field = e.target.name;
    const value = e.target.value;

    if (Object.keys(errors).length > 0) {
      setErrors({});
    }

    updateReview(field, value);
  };

  const handleSubmit = () => {
    let errs = { ...errors };

    if (reviews.firstName === '') {
      errs.firstName = 'Required field';
    }
    if (reviews.lastName === '') {
      errs.lastName = 'Required field';
    }
    if (reviews.email === '') {
      errs.email = 'Required field';
    }

    if (Object.keys(errs).length !== 0) {
      setErrors(errs);
    } else {
      let formData = new FormData();

      if (reviews.images) {
        formData.append(`reviewImage`, reviews.images);
      }
      formData.append('review', reviews.review);
      formData.append('firstName', reviews.firstName);
      formData.append('lastName', reviews.lastName);
      formData.append('email', reviews.email);
      formData.append('productId', product._id);
      formData.append('rating', reviews.rating);
      formData.append('cart', JSON.stringify(cart.cart));
      newReview(formData);
    }
  };

  return (
    <div className="text-center  parent">
      <div className="px-5  py-3">
        <div>
          <h4 className="font-weight-bold my-3 ">ABOUT YOU</h4>
        </div>

        <div>
          <Form onSubmit={(e) => e.preventDefault()}>
            <InputGroup className="my-2">
              <Input
                className={classnames('', { 'is-invalid': errors.firstName })}
                onChange={handleChange}
                name="firstName"
                value={reviews.firstName}
                placeholder="First Name"
              />
              <div className="invalid-feedback">{errors.firstName}</div>
            </InputGroup>
            <InputGroup className="my-2">
              <Input
                className={classnames('', { 'is-invalid': errors.lastName })}
                onChange={handleChange}
                name="lastName"
                value={reviews.lastName}
                placeholder="Last Name"
              />
              <div className="invalid-feedback">{errors.lastName}</div>
            </InputGroup>
            <InputGroup className="my-2">
              <Input
                className={classnames('', { 'is-invalid': errors.email })}
                onChange={handleChange}
                name="email"
                value={reviews.email}
                placeholder="Email"
              />
              <div className="invalid-feedback">{errors.email}</div>
            </InputGroup>

            <Label className="text-muted my-2">
              By submitting, I acknowledge the Terms of Service and Privacy Policy and that my
              review will be publicly posted and shared online.
            </Label>
          </Form>
        </div>
      </div>

      <div style={{ bottom: 0 }}>
        <div className="float-left">
          <Button outline color="dark" className="border-0" onClick={() => previousStep()}>
            {' '}
            Back{' '}
          </Button>
        </div>
        <div className="float-right">
          <Button
            disabled={reviews.loading}
            outline
            color="dark"
            className="border-0"
            onClick={handleSubmit}
          >
            {reviews.loading ? 'Please Wait' : 'Submit'}{' '}
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  reviews: state.reviews,
  cart: state.cart,
});

export default connect(mapStateToProps, { updateReview, newReview })(ReviewStep4);
